// This file is auto-generated by 'scripts/generateIconComponents.ts'. Do not edit it manually.

import { Icon, type IconProps } from '@chakra-ui/react/icon';
import { type Ref } from 'react';

import SVG16 from '../svgs/16x16/icon-google-color-16.svg?react';
import SVG24 from '../svgs/24x24/icon-google-color-24.svg?react';
import { bitkitIcon } from './bitkitIcon';

/** Fixed-color icon: its colors are baked in and not themeable, so `color` is omitted. */
export interface IconGoogleColorProps extends Omit<IconProps, 'color'> {
  size?: '16' | '24';
}

const IconGoogleColor = bitkitIcon(function IconGoogleColor(
  { size = '24', ...props }: IconGoogleColorProps,
  ref: Ref<SVGSVGElement>,
) {
  if (size === '16') {
    return (
      <Icon asChild ref={ref} {...props}>
        <SVG16 width="16" height="16" />
      </Icon>
    );
  }

  return (
    <Icon asChild ref={ref} {...props}>
      <SVG24 width="24" height="24" />
    </Icon>
  );
});

IconGoogleColor.displayName = 'IconGoogleColor';

export default IconGoogleColor;
